<template>
  <div>
    <a-descriptions bordered :size="'small'">
      <a-descriptions-item label="Compañía">
        {{payrollInfo.compania_nombre}}
      </a-descriptions-item>
      <a-descriptions-item label="Empleado">
        {{payrollInfo.id_emp}} {{payrollInfo.nombre_empleado}}
      </a-descriptions-item>
      <a-descriptions-item label="Concepto">
        {{payrollInfo.id_coc}} {{payrollInfo.nombre_concepto}}
      </a-descriptions-item>
      <a-descriptions-item label="Naturaleza">
        {{payrollInfo.naturaleza_concepto}}
      </a-descriptions-item>
      <a-descriptions-item label="Tipo de pago">
        {{payrollInfo.tpay}}
      </a-descriptions-item>
      <a-descriptions-item label="Unidad">
        {{payrollInfo.und}}
      </a-descriptions-item>
      <a-descriptions-item label="Valor base">
        {{payrollInfo.base}}
      </a-descriptions-item>
      <a-descriptions-item label="Valor">
        {{payrollInfo.ammount}}
      </a-descriptions-item>
      <a-descriptions-item label="Valor local">
        {{payrollInfo.ammount_l}}
      </a-descriptions-item>
      <a-descriptions-item label="Año">
        {{payrollInfo.year}}
      </a-descriptions-item>
      <a-descriptions-item label="Mes">
        {{payrollInfo.mes}}
      </a-descriptions-item>
      <a-descriptions-item label="Periodo de liquidación">
        {{payrollInfo.period}}
      </a-descriptions-item>
      <a-descriptions-item label="Proceso">
        {{payrollInfo.prc}}
      </a-descriptions-item>
      <a-descriptions-item label="Forma liq">
        {{payrollInfo.fliq}}
      </a-descriptions-item>
      <a-descriptions-item label="Tliq">
        {{payrollInfo.tliq}}
      </a-descriptions-item>
      <a-descriptions-item label="ID Novedad">
        {{payrollInfo.novelty_id}}
      </a-descriptions-item>
      <a-descriptions-item label="Moneda">
        {{payrollInfo.currency}}
      </a-descriptions-item>
      <a-descriptions-item label="Idtcc">
        {{payrollInfo.id_t_cc}}
      </a-descriptions-item>
      <a-descriptions-item label="Fecha inicial del periodo">
        {{payrollInfo.fecha_inicial}}
      </a-descriptions-item>
      <a-descriptions-item label="Fecha final del periodo">
        {{payrollInfo.fecha_final}}
      </a-descriptions-item>
      <a-descriptions-item label="Fecha del evento">
        {{payrollInfo.fecha_evento}}
      </a-descriptions-item>
    </a-descriptions>
    <br>
    <br>
    <br>
  </div>
</template>
<script>
  export default {
    props: ['payrollInfo'],
    data () {
      return {
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/PayrollPersonalInfo.vue